
const cutExtOff = filename => filename.split(/\.\/|\./).reverse()[1]

const getPics = require.context(".", false, /.*\.(svg|png|jpg)$/)

const pics_filenames = getPics.keys()

const flags = pics_filenames.reduce((acc, file_name) => ({...acc, [cutExtOff(file_name)]: getPics(file_name)}), {})

export default flags